export default "__VITE_ASSET__DGE8AS_K__"